import { useSortOrders } from "../../src/hooks";
import { ReservationCompletedStatuses } from "../../src/store/types";

import { useGetReservationsQuery } from "@stepapp/core";
import { ServiceList } from "../../src/components";
import { AppStorage } from "../../src/services/AppStorage";

const CompletedServices = () => {
  const isAuthenticated = !!AppStorage().get("token");
  const { data, loading, refetch } = useGetReservationsQuery({
    variables: { filter: { status: ReservationCompletedStatuses }, isCustomerApp: true },
    skip: !isAuthenticated,
  });

  const sortedOrders = useSortOrders(data?.listReservations, true);

  return <ServiceList orders={sortedOrders} refetchReservations={refetch} loading={loading} />;
};

export default CompletedServices;
